import React, { ElementType } from 'react';

const SocialLink = ({ href, Icon }: { href: string; Icon: ElementType }) => {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      <Icon size={32} />
    </a>
  );
};

export default SocialLink;
